import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../modules/Request/request';

export const getAccountsWithLicenseList = createAsyncThunk(
  'getAccountsWithLicenseList',
  async (object, { rejectWithValue }) => {
    const { packageId } = object || {};
    const response = await request('/all-accounts-with-license', { method: 'GET', ...(packageId && { params: packageId }) });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
